import { render, staticRenderFns } from "./EditRolePage.vue?vue&type=template&id=76590250"
import script from "./EditRolePage.vue?vue&type=script&lang=js"
export * from "./EditRolePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports